
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../../store/modules/user';
import { getBranchList } from '../../../api/cyclCheck';

@Component({
  name: 'DialogSelectBranch',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })branchVisible!:Boolean;
  @Watch('branchVisible', {
    immediate: true
  })toggleVisible(val: boolean) {
    if (val) {
      this.tableData = [];
      this.radioSelected = '';
      this.getList();
    }
  }

  private formSearch = {
    name: ''
  }
  private loading = false
  private tableData = []
  private radioSelected = ''

  getList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: this.formSearch.name
    };
    getBranchList(params).then(res => {
      if (res && res.data) {
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      this.tableData = [];
      this.showErrorMsg(err.msg);
    });
  }

  handleSearch() {
    this.getList();
  }

  handleClear() {
    this.formSearch.name = '';
    this.getList();
  }

  handleSubmit() {
    // 选择客户后点击确定
    if (this.radioSelected === '') {
      this.$notify({
        title: '提示',
        message: '请选择客户',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return;
    }
    this.$emit('selectcus', this.radioSelected);
  }

  private close() {
    this.$emit('close', false);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
